var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inline-block relative",class:_vm.sizeClasses},[_c('div',{staticClass:"spinner-animation",class:_vm.partClasses}),_c('div',{staticClass:"spinner-animation",class:_vm.partClasses}),_c('div',{staticClass:"spinner-animation",class:_vm.partClasses}),_c('div',{staticClass:"spinner-animation",class:_vm.partClasses})])
}
var staticRenderFns = []

export { render, staticRenderFns }